export default __webpack_public_path__ + "static/media/mail.7e659288.svg";